import { DashboardUrl, getBuildInfo, ReportUrl } from "@common";
import { AppState, BackendBuildInfo, isReportingOnlyCustomer } from "@store";
import * as cn from "classnames";
import { FetchingState } from "rd-redux-http";
import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
    AAdello,
    SideMenuIconDashboardOff,
    SideMenuIconDashboardOn,
    SideMenuIconReportOff,
    SideMenuIconReportOn
} from "../icons";
import "./Navigation.css";
import { SvgIcon } from "./SvgIcon";

export interface NavigationComponentProps {
    selectedPage: NavigationSelectedPage;
    clientId: string;
    disableReportsNavigation: boolean;
    dashboardLink: string;
    backendVersion: BackendBuildInfo;
    onlyReporting: boolean;
}
export interface NavigationComponentState {
    hoveredNavItem: number;
    selectedPage: NavigationSelectedPage;
}

export type NavigationSelectedPage = "dashboard" | "reports" | "campaign" | "users";

export class NavigationComponent extends React.Component<NavigationComponentProps, NavigationComponentState> {
    constructor(props: NavigationComponentProps) {
        super(props);
        this.state = {
            hoveredNavItem: null,
            selectedPage: this.props.selectedPage
        };
    }

    handleNavHover(id: number) {
        this.setState({
            hoveredNavItem: id
        });
    }

    handleNavLeave() {
        this.setState({
            hoveredNavItem: null
        });
    }

    render() {
        const { hoveredNavItem, selectedPage } = this.state;
        const {
            clientId,
            disableReportsNavigation: disableReoprtsNavigation,
            dashboardLink,
            backendVersion,
            onlyReporting
        } = this.props;

        return (
            <nav className="app-menu-navigation">
                <Link className="logo" to={DashboardUrl.format({ clientId: clientId })}>
                    <SvgIcon svg={AAdello} />
                </Link>
                <ul className="tour-common-menu">
                    {!onlyReporting && (
                        <li onMouseOver={e => this.handleNavHover(0)} onMouseLeave={e => this.handleNavLeave()}>
                            <Link to={dashboardLink ? dashboardLink : DashboardUrl.format({ clientId: clientId })}>
                                <SvgIcon
                                    svg={
                                        hoveredNavItem === 0
                                            ? SideMenuIconDashboardOn
                                            : selectedPage === "dashboard"
                                                ? SideMenuIconDashboardOn
                                                : SideMenuIconDashboardOff
                                    }
                                />
                                <span className="nav-title">Dashboard</span>
                            </Link>
                        </li>
                    )}
                    <li onMouseOver={e => this.handleNavHover(2)} onMouseLeave={e => this.handleNavLeave()}>
                        <Link
                            className={cn(
                                disableReoprtsNavigation !== undefined && disableReoprtsNavigation
                                    ? "disabled-reports-link"
                                    : ""
                            )}
                            to={ReportUrl.format({ clientId: clientId, tab: "dynamic" })}
                        >
                            <SvgIcon
                                svg={
                                    hoveredNavItem === 2
                                        ? SideMenuIconReportOn
                                        : selectedPage === "reports"
                                            ? SideMenuIconReportOn
                                            : SideMenuIconReportOff
                                }
                            />
                            <span className="nav-title">Reports</span>
                        </Link>
                    </li>
                </ul>
                <div className="versions">
                    <div className="version_inner-wrapper">
                        <span className="version_title">Frontend:</span>
                        <br />
                        <span>
                            {getBuildInfo().git_commit + " " + getBuildInfo().job_name + " " + getBuildInfo().build_id}
                        </span>
                        <br />
                        {backendVersion && (
                            <>
                                <span className="version_title">Backend:</span>
                                <br />
                                <span>
                                    {backendVersion.git_commit +
                                        " " +
                                        backendVersion.job_name +
                                        " " +
                                        backendVersion.build_id}
                                </span>
                            </>
                        )}
                    </div>
                </div>
            </nav>
        );
    }
}

export interface NavigationProps {
    clientId: string;
    selectedPage: NavigationSelectedPage;
}

export const Navigation = connect(
    (state: AppState, ownProps: NavigationProps): Partial<NavigationComponentProps> => {
        const onlyReporting = isReportingOnlyCustomer(state);
        return {
            disableReportsNavigation:
                FetchingState.isSuccess(state.campaignList.campaigns) &&
                state.campaignList.campaigns.data.filter(c => c.status !== "draft" && c.status !== "pending").length > 0
                    ? false
                    : true,
            dashboardLink: state.pagesState.dashboardLink,
            backendVersion:
                FetchingState.isSuccess(state.pagesState.backendVersion) && state.pagesState.backendVersion.data,
            clientId: ownProps.clientId,
            selectedPage: ownProps.selectedPage,
            onlyReporting
        };
    }
)(NavigationComponent);
